var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"header_wrap black"},[_vm._t("backBtn",function(){return [_c('div',{staticClass:"backBtn_icon"})]}),_c('div',{staticClass:"title"},[_vm._t("title",function(){return [_vm._v(" default ")]})],2),_c('div',{staticClass:"blank"})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }